export default {"src":"/_next/static/media/patio-400-sliding.95246f3b.svg","height":1000,"width":1000};